/**
 * @file formValidation.js
 * @description Contains utility functions for form validation, providing a flexible
 * and reusable way to validate form data against a defined schema.
 */

/**
 * Validates form data against a provided validation schema
 * @param {Object} formData - The form data to validate
 * @param {Object} validationSchema - Schema defining validation rules for each field
 * @returns {Object} Object containing validation errors, empty if no errors
 *
 * @example
 * const schema = {
 *   username: {
 *     required: true,
 *     minLength: 3,
 *     pattern: /^[a-zA-Z0-9]+$/,
 *     message: "Only alphanumeric characters allowed"
 *   }
 * };
 * const errors = validateForm({ username: "ab" }, schema);
 */
export const validateForm = (formData, validationSchema) => {
  const errors = {};

  Object.keys(validationSchema).forEach((field) => {
    const value = formData[field];
    const fieldValidation = validationSchema[field];

    if (fieldValidation.required && !value) {
      errors[field] = "This field is required";
    } else if (
      fieldValidation.minLength &&
      value.length < fieldValidation.minLength
    ) {
      errors[field] = `Minimum length is ${fieldValidation.minLength}`;
    } else if (
      fieldValidation.pattern &&
      !fieldValidation.pattern.test(value)
    ) {
      errors[field] = fieldValidation.message || "Invalid format";
    }
  });

  return errors;
};
